/// <amd-module name="Analytics/Shared/Visuals/Common/Components/AnalyticsUnavailableMessage" />
import * as React from "react";
import { filterXSS } from "xss";
import { xssStyleDefaultOptions } from "xss/PresetOptions";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Button } from "VSSUI/Button";
import { Image } from "VSSUI/Image";
import { Link } from "VSSUI/Link";
import { css } from "VSSUI/Util";

export interface IAnalyticsUnavailableMessageProps extends IVssComponentProperties {
    imageName?: string;
    iconName?: string;
    info?: string;
    message?: string;
    suggestion?: string;
    buttonText?: string;
    buttonUrl?: string;
    linkText?: string;
    linkUrl?: string;
    ariaDescription?: string;
    messageClassName?: string;
}

export class AnalyticsUnavailableMessage extends VssComponent<IAnalyticsUnavailableMessageProps, {}> {
    public render(): JSX.Element {
        const resourceLocation = getAssetLocation(
            this.context.pageContext,
            "ms.vss-analyticsshared-web/analytics-shared-common/images/" + this.props.imageName
        );

        return (
            /* tslint:disable:react-no-dangerous-html */
            <div className={css("ax-message-div", "flex-column", "flex-center", this.props.className || "")}>
                {this.props.imageName && <Image className={"ax-message-image"} src={resourceLocation} alt={""} />}
                {this.props.iconName && <span className={css("ax-message-icon fabric-icon fontSizeXXXL", "ms-Icon--" + this.props.iconName)} />}
                {this.props.message && (
                    <span className={css(this.props.messageClassName || "ax-message-message-font", "ax-message-message")}>{this.props.message}</span>
                )}
                {this.props.suggestion && (
                    <span
                        className={"ax-message-suggestion"}
                        dangerouslySetInnerHTML={{ __html: filterXSS(this.props.suggestion, xssStyleDefaultOptions) }}
                    />
                )}
                {this.props.buttonText && (
                    <Button
                        primary={true}
                        className="ax-message-button"
                        href={this.props.buttonUrl}
                        target="_blank"
                        ariaLabel={this.props.ariaDescription}
                    >
                        {this.props.buttonText}
                    </Button>
                )}
                {this.props.linkText && (
                    <Link className="ax-message-link" href={this.props.linkUrl} ariaLabel={this.props.ariaDescription}>
                        {this.props.linkText}
                    </Link>
                )}
                {this.props.info && <span className={"ax-message-info"}>{this.props.info}</span>}
            </div>
            /* tslint:enable:react-no-dangerous-html */
        );
    }
}
